window.googletag = window.googletag || { cmd: [] };

const isMobileDevice = () => window.innerWidth <= 600;

const p_ads = {};

const REFRESH_KEY = 'refresh';
const REFRESH_VALUE = 'true';
const SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;

const path_ads = window.ATL_DATA?.is_homepage
    ? '/157669170/atlantida/home-page'
    : '/157669170/atlantida/conteudo';

const pageTargeting = {
    dominio: window.location.hostname,
    content_type: window.ATL_DATA?.content_type,
    categoria: window.ATL_DATA?.category,
    slug: window.ATL_DATA?.slug,
    veiculo: window.ATL_DATA?.channel,
    tags: window.ATL_DATA?.tags,
    autor: window.ATL_DATA?.author,
    programa: window.ATL_DATA?.radio_show
};

googletag.cmd.push(() => {
    Object.entries(pageTargeting).forEach(([key, value]) => {
        googletag.pubads().setTargeting(key, value);
    });

    anchorAdSlot = googletag.defineOutOfPageSlot(path_ads, googletag.enums.OutOfPageFormat.BOTTOM_ANCHOR);


    const defineAdSlot = (id, sizes, format) => {
        const element = document.getElementById(id);
        if (element) {
            p_ads[id] = googletag.defineSlot(path_ads, sizes, id)
                .addService(googletag.pubads())
				.setTargeting(REFRESH_KEY, REFRESH_VALUE)
				.setTargeting('refreshed_slot', 'true')
                .setTargeting('format', format);
        }
    };

	const defineMultipleAdSlots = (prefix, sizes, format) => {
		document.querySelectorAll(`div[id^="${prefix}"]`).forEach((element, index) => {
			const id = element.id;
			const formatWithIndex = prefix === 'in_text' && index < 2 ? `${format}_${index}` : format;
			p_ads[id] = googletag.defineSlot(path_ads, sizes, id)
				.addService(googletag.pubads())
				.setTargeting(REFRESH_KEY, REFRESH_VALUE)
				.setTargeting('refreshed_slot', 'true')
				.setTargeting('format', formatWithIndex);
		});
	};

	// billboard_top
    defineAdSlot(
        'div-gpt-ad-billboard_top',
        isMobileDevice() ? [[300, 100], [320, 100], [1, 1]] : [[970, 250],[1, 1]],
        'billboard_top'
    );

	// billboard_middle
	defineMultipleAdSlots('div-gpt-ad-billboard_middle_', isMobileDevice()
        ? [[300, 100], [300, 250], [320, 100], [336, 280], [1, 1]]
        : [[970, 150], [970, 250], [1, 1]],
        'billboard_middle'
    );

	// billboard_bottom
    defineAdSlot('div-gpt-ad-billboard_bottom', isMobileDevice()
		? [[300, 100], [300, 250], [320, 100], [336, 280], [1, 1]]
		: [[970, 250], [970, 150], [1, 1]],
        'billboard_bottom'
    );


    defineMultipleAdSlots('div-gpt-ad-intext_', isMobileDevice()
        ? [[300, 100], [300, 250], [320, 100], [336, 280], [1, 1]]
        : [[970, 150], [970, 250], [1, 1]],
        'in_text'
    );

	googletag.pubads().addEventListener('impressionViewable', function (event) {
		let slot = event.slot;
		if (slot.getTargeting(REFRESH_KEY).indexOf(REFRESH_VALUE) > -1) {
			slot.setTargeting('refreshed_slot', 'true');
			setTimeout(function () {
				googletag.pubads().refresh([slot]);
			}, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
		}
	});

    googletag.pubads().enableLazyLoad({
        fetchMarginPercent: 0,
        renderMarginPercent: 0,
        mobileScaling: 2.0
    });

    googletag.pubads().addEventListener('slotRequested', event =>
        updateSlotStatus(event.slot.getSlotElementId(), 'fetched')
    );
    googletag.pubads().addEventListener('slotOnload', event =>
        updateSlotStatus(event.slot.getSlotElementId(), 'rendered')
    );

    googletag.pubads().enableSingleRequest();
    googletag.enableServices();
});

googletag.cmd.push(() => {
    ['div-gpt-ad-billboard_top'].forEach(id => {
        googletag.display(id);
    });

});

const updateSlotStatus = (slotId, state) => console.log(`${slotId} / ${state}`);
